var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wrap-ftm"},[_c('f-view-transition',{attrs:{"watch-route":"","views-structure":_vm.viewsStructure}},[_c('router-view',{key:_vm.routerKey})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }